export const PERMISSION_REQUIRED = 'permission-required'
export const PERMISSION_REQUESTED = 'permission-requested'
export const PERMISSION_AWAITED = 'permission-awaited'
export const PERMISSION_GRANTED = 'permission-granted'
